import React from "react"

import Layout from "../components/layout"
import Image from "../components/image"
import SEO from "../components/seo"

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <h1>Looking for NVMe Price</h1>
    <h2>Comparing all NVMe prices on a daily basis</h2>

    <div style={{ maxWidth: `50px`, marginBottom: `1.45rem` }}>
      <Image />
    </div>
  </Layout>
)

export default IndexPage
